import React from 'react';
import { Table } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { LandUseChange } from '../../../../../../../services/types/Calculator';
import NumberFormatterSinSeparador from '../../../NumberFormatterSinSeparador';

interface Props {
  landUseChange: LandUseChange;
}

const LandUseChangeDetails: React.FC<Props> = ({ landUseChange }) => {
  const { t } = useTranslation();

  return (
    <div className="table-wrapper">
      <Table
        responsive
        className="table--bordered calculator table-details"
        style={{ tableLayout: 'fixed' }}
      >
        <colgroup>
          <col style={{ width: '42%' }} />
          <col style={{ width: '13%' }} />
          <col style={{ width: '16%' }} />
          <col style={{ width: '16%' }} />
          <col style={{ width: '13%' }} />
        </colgroup>
        <thead>
          <tr>
            <th>{t('Land Cover Type')}</th>
            <th>{t('Area Cleared (ha)')}</th>
            <th>{t('Above Ground Biomass (Dry tons per ha)')}</th>
            <th>{t('Below Ground Biomass (Dry tons per ha)')}</th>
            <th>{t('Total Carbon')}</th>
          </tr>
        </thead>
        <tbody>
          {landUseChange.rows.map((row) => (
            <tr key={row.id}>
              <td>{row.coverType}</td>
              <td>
                <NumberFormatterSinSeparador value={row.area} />
              </td>
              <td>
                <NumberFormatterSinSeparador value={row.aboveGBCarbon} />
              </td>
              <td>
                <NumberFormatterSinSeparador value={row.belowGBCarbon} />
              </td>
              <td>
                <NumberFormatterSinSeparador value={row.totalCarbon} />
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            {/* espaciador intencional, sin contenido */}
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <td colSpan={5} />
          </tr>
        </tfoot>
      </Table>
    </div>
  );
};

export default LandUseChangeDetails;
